import OSmesku from '../../images/smesko/osmesku.png';
import GdeSmo from '../../images/smesko/gdesmo.png';
import Dogadjaji from '../../images/smesko/dogadjaji.png';

function ONama() {

    return (

        <div className='wrapperLight'>

            <div className=''>

                <center>
                    <img src={OSmesku} className='responsive' alt='O Gorskom Smešku'/>
                </center>

                {/*<hr className='horizon' />*/}

                Na Popovici, na desetak minuta od grada, nalazi se Udruženje prijatelja prirode "Gorski Smeško" gde možete da se odmorite 
                nakon šetnje po Fruškoj Gori ili samo da se sklonite od gradske vreve.<br /><br />
                Udruženje je smešteno u prelepom šumskom ambijentu i uređeno tako da slavi prirodu i opuštenost. U skladu sa misijom očuvanja 
                prirode, stolice i stolovi su napravljeni od prirodnih i recikliranih materijala kao što su drvene palete, stare automobilske 
                gume, stara burad i slično.
                <br /><br />
                Jedan stari auto poslužio je kao zgodan dvosed, a na nekoliko mesta su okačene pletene ležaljke za odmaranje i leškarenje. 
                Ambijent je upotpunjen starim kombijem koji je postao pravo umetničko delo budući da je maštovito oslikan. U ovom originalnom 
                ambijentu se povremeno organizuju projekcije filmova, džez koncerti, kao i drugi događaji.
                <br /><br />
                Naravno, dobrodošli su i vaši kućni ljubimci.
                <br />

            </div>

            <hr className='hr' />

            <div className=''>

                <center>
                    <img src={GdeSmo} className='responsive' alt='Gde se nalazimo'/>
                </center>

                {/*<hr className='horizon' />*/}

                Od okretnice autobusa na Popovici se krene putem ka Orlovom bojištu i na nekih 50 metara sa leve strane ćete pronaći Udruženje 
                prijatelja prirode "Gorski Smeško".<br /><br />
                U slucaju nedoumice oko putanje do Gorskog Smeska pratite putanju stajalista autobusa na ulici Fruskogorski Put.<br /><br />

                <center>

                    <iframe src="https://www.google.com/maps/embed?pb=!1m45!1m12!1m3!1d44962.22913007172!2d19.800173650813434!3d45.2247493478187!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m30!3e0!4m4!1s0x475b1056b704296b%3A0x717d661afa703571!3m2!1d45.2654728!2d19.8295657!4m5!1s0x475b0ff930dadc73%3A0x89496d38b83a7d84!2zSnAg4oCeTmFjaW9uYWxuaSBQYXJrIEZydcWha2EgR29yYeKAnQ!3m2!1d45.2232647!2d19.8422655!4m5!1s0x475b0f87e08d2b1f%3A0xb01a10e083474c84!2z0KTRgNGD0YjQutC-0LPQvtGA0YHQutC4INC_0YPRgiwgU3JlbXNrYSBLYW1lbmljYQ!3m2!1d45.2013993!2d19.832263599999997!4m5!1s0x475b05ad4c391195%3A0x1a96ae5109017cdc!2sMountain%20Spa%20Yin%20%26%20Yang!3m2!1d45.1898864!2d19.8335291!4m5!1s0x475b05862c52d3f3%3A0x4b714cfea48484c!2sCaffe%20Gorski%20sme%C5%A1ko%2C%20Popovica%20-%20Kraljeva%20Stolica%2C%20Ledinci!3m2!1d45.1840688!2d19.8227056!5e0!3m2!1sen!2srs!4v1749372083094!5m2!1sen!2srs" 
                    width="100%" 
                    height="450" 
                    title='Gorski Smeško map'
                    style={{ border: 0 }} 
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade"></iframe>

                    {/*<iframe
                    width='100%'
                    title='Gorski Smeško map'
                    style={{ border: 0 }}
                    allowfullscreen=''
                    loading='lazy'
                    referrerpolicy='no-referrer-when-downgrade'
                    src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d789.1283462090591!2d19.822780985136703!3d45.18439698125053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b05862c52d3f3%3A0x4b714cfea48484c!2sCaffe%20Gorski%20sme%C5%A1ko!5e0!3m2!1ssr!2srs!4v1661516072710!5m2!1ssr!2srs'></iframe>*/}

                </center>

                <br />

                <center>

                    U slučaju pametnih telefona i tableta koristite sledeci link da bi dobili tačnu rutu u Goodle Maps aplikaciji: <br />
                    <a href='https://maps.app.goo.gl/ageffsRr7i5nnhMJA' title='Google Maps putanja' rel='noreferrer' target='_blank' alt=''>Google Maps putanja do Gorskog Smeška</a>.

                </center>

            </div>

            <hr className='hr' />

            <div className=''>

                <center>
                    <img src={Dogadjaji} className='responsive' alt='Dogadjaji i aktivnosti'/>
                </center>

                {/*<hr className='horizon' />*/}

                Za najnovije informacije o dogadjajima i aktivnostima molimo vas da posetite naše&nbsp;
                <a href='https://www.facebook.com/gorskismesko/' title='Gorski Smesko Facebook' rel='noreferrer' target='_blank'>Facebook</a> i &nbsp;
                <a href='https://www.instagram.com/gorski_smesko/' title='Gorski Smesko Instagram' rel='noreferrer' target='_blank'>Instagram </a>
                stranice.

            </div>

        </div>

    );

}

export default ONama;
